module.exports = __webpack_public_path__ + "static/media/fire-2.4fedc076.svg";